import React, {
  useEffect,
} from 'react';
import {
  useParams,
  useNavigate,
} from 'react-router-dom';
import {
  useDispatch,
} from 'react-redux';
import {
  toast,
} from 'react-toastify';

import {
  coreActions,
} from '@gymcloud/core';

import {
  Spinner,
} from 'web-components';
import {
  urls,
} from 'web-urls';

import * as S from '../styled';

const ConfirmEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const onSuccess = () => {
      toast('Email successfully changed');
      navigate(urls.login);
    };
    const onError = (e: any) => {
      const json = e?.response?.data;
      if (json) {
        const text = Object.keys(json).map(
          k => `${k}: ${Array.isArray(json[k]) ? json[k].join('. ') : json[k]}`,
        ).join('\n');
        toast.error(text);
      }

      navigate('/login');
    };

    if (!token) {
      navigate('/login');
      return;
    }

    dispatch(
      coreActions.confirmEmail(
        token,
        onSuccess,
        onError,
      ),
    );
  }, [token]);

  return (
    <S.PageWrap>
      <Spinner />
    </S.PageWrap>
  );
};

export default ConfirmEmail;
